import { replaceMaterialSnippets } from '#imports';

export const setupCategoryTextMaterial = (shader, uniforms = {}) => {
    replaceMaterialSnippets({
        material: shader,
        uniforms: {
            uSlantAngle: { value: 0.2 }, // Default italic slant (radians)
            ...uniforms,
        },
        vertex: [
            {
                snippet: 'attribute vec3 aTroikaGlyphColor;',
                newSnippet: /* glsl */ `
                        attribute vec3 aOffset;
                        attribute float aAlpha;
                        varying float vAlpha;
                        varying vec3 vTransformed;
                        varying float vArcAngle;
                        uniform float uSlantAngle;
                    `,
            },
            {
                snippet: 'position.xy = mix(bounds.xy, bounds.zw, clippedXY);',
                newSnippet: /* glsl */ `
                    // Apply italic slant transformation
                    // Shear the text by offsetting X based on Y position
                    float slantOffset = position.y * tan(uSlantAngle);
                    position.x += slantOffset;
                    
                    // do position stuff here
                    // uTroikaTotalBounds
                    // uTextArcLength
                `,
            },
            {
                snippet: 'vec3 transformed = vec3( troika_position_1 );',
                newSnippet: /* glsl */ `
                        transformed += aOffset;
                        vAlpha = aAlpha;
                        vTransformed = transformed;
                    `,
            },
        ],
        fragment: [
            {
                snippet: 'varying vec3 vTroikaGlyphColor;',
                newSnippet: /* glsl */ `
                        varying float vAlpha;
                        varying vec3 vTransformed;
                        varying float vArcAngle;
                    `,
            },
            {
                snippet: 'gl_FragColor.a *= edgeAlpha;',
                newSnippet: /* glsl */ `
                        // do fragment stuff here
                        gl_FragColor.a *= vAlpha;
                    `,
            },
        ],
    });
};
